import { useQuery } from '@tanstack/react-query';
import { getSharedCarePlan, getSharedCareGuideHubResources } from '../api/sharedCarePlanApi';

export const sharedCarePlanKeys = {
  detail: (id: string) => ['shared-care-plan', id] as const,
  hubResources: (id: string) => ['shared-care-plan', id, 'hub-resources'] as const,
};

export function useSharedCarePlan(engagementId: string | undefined) {
  return useQuery({
    queryKey: sharedCarePlanKeys.detail(engagementId ?? ''),
    queryFn: () => getSharedCarePlan(engagementId as string),
    enabled: Boolean(engagementId),
    refetchOnWindowFocus: false,
  });
}

/**
 * Feature 078: careseeker mirror of useFpQaHubResources — the same Key Resources
 * bundle the FP sees, behind the shared-plan-authorized endpoint.
 */
export function useSharedCareGuideHubResources(engagementId: string | undefined) {
  return useQuery({
    queryKey: sharedCarePlanKeys.hubResources(engagementId ?? ''),
    queryFn: () => getSharedCareGuideHubResources(engagementId as string),
    enabled: Boolean(engagementId),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
